import L from "axios";
import M from "axios-retry";
import { createBrowserClient as k } from "@slardar/web/maliva";
import { createBrowserClient as q } from "@slardar/web/oci";
import H, { murmurX64Hash128 as J, hashComponents as z } from "@fingerprintjs/fingerprintjs";
const u = /version\/(\d+(\.?_?\d+)+)/i, Q = {
  name: "unknown",
  version: "0"
}, f = {
  REPORT_SUCCEED: "gp_fp_sdk_report_succeed",
  API_FAIL: "gp_fp_sdk_api_fail",
  TIMEOUT_REPORT_FAIL: "gp_fp_sdk_settimeout_report_fail",
  REPORT_LOOP_FAIL: "gp_fp_sdk_report_loop_fail",
  GET_BROWSER_FAIL: "gp_fp_sdk_get_browser_fail"
};
function F(t) {
  return typeof t == "function";
}
function Y(t) {
  return typeof t == "object" && t !== null;
}
const O = () => {
}, X = function() {
  try {
    return !(typeof window != "undefined" && document);
  } catch (t) {
    return !0;
  }
}();
function K() {
  return !(!Y(window.navigator) || !F(window.navigator.sendBeacon));
}
function l(t, r) {
  const e = r.match(t);
  return e && e.length > 0 && e[1] || "";
}
function E(t, r) {
  const e = r.match(t);
  return e && e.length > 1 && e[2] || "";
}
const S = (...t) => {
  console.warn("[@pipo-lib/fingerprint]", Date.now(), ...t);
}, Z = () => ({
  domain: ""
}), ee = () => ({
  init: O,
  getDeviceId: O
}), re = "pipo_next", v = class {
  constructor(t) {
    return v.instance ? v.instance : (this.initSlardar(t), v.instance = this, this);
  }
  initSlardar(t = {}) {
    var r, e;
    const { idc: s } = t;
    try {
      s === "ttp" ? this.slardar = q() : this.slardar = k(), (r = this.slardar) == null || r.call(this, "init", { bid: re }), (e = this.slardar) == null || e.call(this, "start");
    } catch (i) {
    }
  }
  getSlardar() {
    return this.slardar;
  }
};
let V = v;
V.instance = null;
const p = new V().getSlardar();
class h {
  constructor() {
    this.time = Date.now();
  }
  stop() {
    return Date.now() - this.time;
  }
}
var te = (t, r, e) => new Promise((s, i) => {
  var n = (o) => {
    try {
      a(e.next(o));
    } catch (c) {
      i(c);
    }
  }, d = (o) => {
    try {
      a(e.throw(o));
    } catch (c) {
      i(c);
    }
  }, a = (o) => o.done ? s(o.value) : Promise.resolve(o.value).then(n, d);
  a((e = e.apply(t, r)).next());
});
class m {
  getValue() {
  }
  getComponent() {
    return te(this, null, function* () {
      return new Promise((r) => {
        setTimeout(() => {
          const e = new h(), s = this.getValue(), i = e.stop();
          r({ value: s, duration: i });
        }, 0);
      });
    });
  }
}
class ne extends m {
  getValue() {
    let r = "";
    return typeof navigator != "undefined" && (navigator == null ? void 0 : navigator.userAgent) && (r = navigator.userAgent), r;
  }
}
const w = J;
function g() {
  if (typeof document == "undefined")
    return null;
  const t = document.createElement("canvas");
  return t.width = 256, t.height = 128, t.getContext("webgl", { preserveDrawingBuffer: !0 });
}
class oe extends m {
  getValue() {
    var r, e, s, i;
    const n = g(), d = (r = n == null ? void 0 : n.createBuffer) == null ? void 0 : r.call(n), a = (e = n == null ? void 0 : n.createProgram) == null ? void 0 : e.call(n), o = (s = n == null ? void 0 : n.createShader) == null ? void 0 : s.call(n, n.VERTEX_SHADER), c = (i = n == null ? void 0 : n.createShader) == null ? void 0 : i.call(n, n.FRAGMENT_SHADER);
    if (!n || !d || !a || !o || !c || typeof Uint8Array == "undefined")
      return "";
    let b = "";
    try {
      n.bindBuffer(n.ARRAY_BUFFER, d), n.bufferData(
        n.ARRAY_BUFFER,
        new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.7321, 0]),
        n.STATIC_DRAW
      );
      const N = 3, W = 3;
      n.shaderSource(
        o,
        "attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}"
      ), n.compileShader(o), n.shaderSource(
        c,
        "precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}"
      ), n.compileShader(c), n.attachShader(a, o), n.attachShader(a, c), n.linkProgram(a), n.useProgram(a);
      const y = n.getAttribLocation(a, "attrVertex"), j = n.getUniformLocation(a, "uniformOffset");
      n.enableVertexAttribArray(y), n.vertexAttribPointer(
        y,
        N,
        n.FLOAT,
        !1,
        0,
        0
      ), n.uniform2f(j, 1, 1), n.drawArrays(n.TRIANGLE_STRIP, 0, W);
      const P = new Uint8Array(131072);
      n.readPixels(0, 0, 256, 128, n.RGBA, n.UNSIGNED_BYTE, P);
      const G = JSON.stringify(P).replace(/,?"[0-9]+":/g, "").replace(/^{[0]+}$/g, "");
      b = w(G);
    } finally {
      return b;
    }
  }
}
class se extends m {
  getValue() {
    var r, e;
    const s = g(), i = (r = s == null ? void 0 : s.getExtension) == null ? void 0 : r.call(s, "WEBGL_debug_renderer_info");
    let n = "";
    return s && i && (n = (e = s.getParameter) == null ? void 0 : e.call(s, i.UNMASKED_RENDERER_WEBGL)), n;
  }
}
class ie extends m {
  getValue() {
    var r, e;
    const s = g(), i = (r = s == null ? void 0 : s.getExtension) == null ? void 0 : r.call(s, "WEBGL_debug_renderer_info");
    let n = "";
    return s && i && (n = (e = s.getParameter) == null ? void 0 : e.call(s, i.UNMASKED_VENDOR_WEBGL)), n;
  }
}
var ae = (t, r, e) => new Promise((s, i) => {
  var n = (o) => {
    try {
      a(e.next(o));
    } catch (c) {
      i(c);
    }
  }, d = (o) => {
    try {
      a(e.throw(o));
    } catch (c) {
      i(c);
    }
  }, a = (o) => o.done ? s(o.value) : Promise.resolve(o.value).then(n, d);
  a((e = e.apply(t, r)).next());
});
const ce = () => ae(void 0, null, function* () {
  return {
    userAgent: yield new ne().getComponent(),
    webglUnmaskedVendor: yield new ie().getComponent(),
    webglUnmaskedRenderer: yield new se().getComponent(),
    webglImageHash: yield new oe().getComponent()
  };
});
var le = Object.defineProperty, de = Object.defineProperties, ue = Object.getOwnPropertyDescriptors, I = Object.getOwnPropertySymbols, ve = Object.prototype.hasOwnProperty, fe = Object.prototype.propertyIsEnumerable, R = (t, r, e) => r in t ? le(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[r] = e, pe = (t, r) => {
  for (var e in r || (r = {}))
    ve.call(r, e) && R(t, e, r[e]);
  if (I)
    for (var e of I(r))
      fe.call(r, e) && R(t, e, r[e]);
  return t;
}, me = (t, r) => de(t, ue(r));
function _e(t) {
  if (!(t != null && t.geometry) || !(t != null && t.text))
    return t;
  const r = w(t.geometry), e = w(t.text);
  return me(pe({}, t), { text: e, geometry: r });
}
var he = Object.defineProperty, we = Object.defineProperties, ge = Object.getOwnPropertyDescriptors, x = Object.getOwnPropertySymbols, be = Object.prototype.hasOwnProperty, ye = Object.prototype.propertyIsEnumerable, A = (t, r, e) => r in t ? he(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[r] = e, Pe = (t, r) => {
  for (var e in r || (r = {}))
    be.call(r, e) && A(t, e, r[e]);
  if (x)
    for (var e of x(r))
      ye.call(r, e) && A(t, e, r[e]);
  return t;
}, Oe = (t, r) => we(t, ge(r));
function Ee(t) {
  return typeof (t == null ? void 0 : t.value) == "undefined" ? "" : typeof (t == null ? void 0 : t.value) == "string" ? t.value : JSON.stringify(t == null ? void 0 : t.value);
}
function Se(t) {
  const r = {};
  return Object.keys(t).forEach((e) => {
    r[e] = Oe(Pe({}, t[e] || {}), {
      value: ""
    }), r[e].value = Ee(t[e]);
  }), r;
}
var Ie = Object.defineProperty, B = Object.getOwnPropertySymbols, Re = Object.prototype.hasOwnProperty, xe = Object.prototype.propertyIsEnumerable, D = (t, r, e) => r in t ? Ie(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[r] = e, C = (t, r) => {
  for (var e in r || (r = {}))
    Re.call(r, e) && D(t, e, r[e]);
  if (B)
    for (var e of B(r))
      xe.call(r, e) && D(t, e, r[e]);
  return t;
}, Ae = (t, r, e) => new Promise((s, i) => {
  var n = (o) => {
    try {
      a(e.next(o));
    } catch (c) {
      i(c);
    }
  }, d = (o) => {
    try {
      a(e.throw(o));
    } catch (c) {
      i(c);
    }
  }, a = (o) => o.done ? s(o.value) : Promise.resolve(o.value).then(n, d);
  a((e = e.apply(t, r)).next());
});
const Be = () => Ae(void 0, null, function* () {
  var t, r;
  let e = {};
  try {
    const i = yield (yield H.load({ debug: !1, monitoring: !1 })).get();
    (r = (t = i == null ? void 0 : i.components) == null ? void 0 : t.canvas) != null && r.value && (i.components.canvas.value = _e(
      i.components.canvas.value
    ));
    const n = (yield ce()) || {}, d = C(C({}, (i == null ? void 0 : i.components) || {}), n);
    e = Se(d);
  } finally {
    return e;
  }
});
var De = (t, r, e) => new Promise((s, i) => {
  var n = (o) => {
    try {
      a(e.next(o));
    } catch (c) {
      i(c);
    }
  }, d = (o) => {
    try {
      a(e.throw(o));
    } catch (c) {
      i(c);
    }
  }, a = (o) => o.done ? s(o.value) : Promise.resolve(o.value).then(n, d);
  a((e = e.apply(t, r)).next());
});
const Ce = () => De(void 0, null, function* () {
  const t = yield Be(), r = {}, e = z(t);
  return Object.keys(t).forEach((s) => {
    r[s] = t[s].value || "";
  }), { info: r, id: e };
}), Te = [
  {
    test: [/opera/i],
    describe(t) {
      const r = {
        name: "Opera"
      }, e = l(u, t) || l(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/opr\/|opios/i],
    describe(t) {
      const r = {
        name: "Opera"
      }, e = l(/(?:opr|opios)[\s/](\S+)/i, t) || l(u, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/coast/i],
    describe(t) {
      const r = {
        name: "Opera Coast"
      }, e = l(u, t) || l(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(t) {
      const r = {
        name: "Opera Touch"
      }, e = l(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, t) || l(u, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/yabrowser/i],
    describe(t) {
      const r = {
        name: "Yandex Browser"
      }, e = l(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, t) || l(u, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(t) {
      const r = {
        name: "UC Browser"
      }, e = l(u, t) || l(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(t) {
      const r = {
        name: "Maxthon"
      }, e = l(u, t) || l(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(t) {
      const r = {
        name: /qqbrowserlite/i.test(t) ? "QQ Browser Lite" : "QQ Browser"
      }, e = l(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, t) || l(u, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/msie|trident/i],
    describe(t) {
      const r = {
        name: "Internet Explorer"
      }, e = l(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/\sedg\//i],
    describe(t) {
      const r = {
        name: "Microsoft Edge"
      }, e = l(/\sedg\/(\d+(\.?_?\d+)+)/i, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(t) {
      const r = {
        name: "Microsoft Edge"
      }, e = E(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(t) {
      const r = {
        name: "WebOS Browser"
      }, e = l(u, t) || l(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(t) {
      const r = {
        name: "Firefox"
      }, e = l(
        /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,
        t
      );
      return e && (r.version = e), r;
    }
  },
  {
    test: [/electron/i],
    describe(t) {
      const r = {
        name: "Electron"
      }, e = l(/(?:electron)\/(\d+(\.?_?\d+)+)/i, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/chromium/i],
    describe(t) {
      const r = {
        name: "Chromium"
      }, e = l(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, t) || l(u, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(t) {
      const r = {
        name: "Chrome"
      }, e = l(
        /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,
        t
      );
      return e && (r.version = e), r;
    }
  },
  {
    test: [/SE\s2\.X/i],
    describe(t) {
      const r = {
        name: "Sougou"
      }, e = "2";
      return r.version = e, r;
    }
  },
  {
    test(t) {
      const r = !t.test(/like android/i), e = t.test(/android/i);
      return r && e;
    },
    describe(t) {
      const r = {
        name: "Android Browser"
      }, e = l(u, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/safari|applewebkit/i],
    describe(t) {
      const r = {
        name: "Safari"
      }, e = l(u, t);
      return e && (r.version = e), r;
    }
  },
  {
    test: [/.*/i],
    describe(t) {
      const r = /^(.*)\/(.*) /, e = /^(.*)\/(.*)[ \t]\((.*)/, i = t.search("\\(") !== -1 ? e : r;
      return {
        name: l(i, t),
        version: E(i, t)
      };
    }
  }
];
class $e {
  constructor(r) {
    this.ua = r, this.parsedResult = {};
  }
  getBrowser() {
    var r, e;
    try {
      return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
    } catch (s) {
      return (e = (r = p) == null ? void 0 : r.sendEvent) == null || e.call(r, {
        name: f.GET_BROWSER_FAIL
      }), {};
    }
  }
  getBrowserName() {
    return this.getBrowser().name;
  }
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  parseBrowser() {
    this.parsedResult.browser = Q;
    const r = Te.find((e) => F(e.test) ? e.test(this) : Array.isArray(e.test) ? e.test.some((s) => this.test(s)) : !1);
    return r && (this.parsedResult.browser = r.describe(this.ua)), this.parsedResult.browser;
  }
  test(r) {
    return r.test(this.ua);
  }
}
var _ = (t, r, e) => new Promise((s, i) => {
  var n = (o) => {
    try {
      a(e.next(o));
    } catch (c) {
      i(c);
    }
  }, d = (o) => {
    try {
      a(e.throw(o));
    } catch (c) {
      i(c);
    }
  }, a = (o) => o.done ? s(o.value) : Promise.resolve(o.value).then(n, d);
  a((e = e.apply(t, r)).next());
});
const U = L.create({
  timeout: 5e3
});
M(U, { retries: 3 });
class Le {
  constructor() {
    this.sendReportLoop = (r, e) => _(this, null, function* () {
      this.reportTimer && clearTimeout(this.reportTimer);
      const s = () => _(this, null, function* () {
        yield this.sendReport(r, e), this.reportTimer = setTimeout(() => _(this, null, function* () {
          var i, n;
          try {
            yield s();
          } catch (d) {
            (n = (i = p) == null ? void 0 : i.sendEvent) == null || n.call(i, {
              name: f.TIMEOUT_REPORT_FAIL
            });
          }
        }), 3e4);
      });
      yield s();
    }), this.sendReport = this.initReport();
  }
  initReport() {
    return K() ? this.beaconTransport() : this.axiosTransport();
  }
  sendReportOnce(r, e) {
    return U.post(r, e);
  }
  beaconTransport() {
    return (e, s) => {
      window.navigator.sendBeacon.bind(window.navigator)(e, JSON.stringify(s)) || this.axiosTransport().call(this, e, s);
    };
  }
  axiosTransport() {
    return (e, s) => L.post(e, JSON.stringify(s));
  }
}
class Fe {
  constructor() {
    this.browserInfo = new $e(window.navigator.userAgent).getBrowser();
  }
  getFeature() {
    const r = this.browserInfo;
    return {
      TimezoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
      Referer: document.referrer,
      CookieEnabled: navigator.cookieEnabled.toString(),
      ScreenWidth: window.screen.width.toString(),
      ScreenHeight: window.screen.height.toString(),
      ScreenResolution: `[${window.devicePixelRatio * window.screen.width}, ${window.devicePixelRatio * window.screen.height}]`,
      BrowserLanguage: navigator.language,
      BrowserPlatform: navigator.platform,
      BrowserName: r.name,
      BrowserVersion: r.version,
      BrowserOnline: navigator.onLine.toString(),
      IsFlash: "false",
      FlashVersion: "0",
      JavascriptEnable: "true"
    };
  }
}
var Ve = Object.defineProperty, T = Object.getOwnPropertySymbols, Ue = Object.prototype.hasOwnProperty, Ne = Object.prototype.propertyIsEnumerable, $ = (t, r, e) => r in t ? Ve(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[r] = e, We = (t, r) => {
  for (var e in r || (r = {}))
    Ue.call(r, e) && $(t, e, r[e]);
  if (T)
    for (var e of T(r))
      Ne.call(r, e) && $(t, e, r[e]);
  return t;
}, je = (t, r, e) => new Promise((s, i) => {
  var n = (o) => {
    try {
      a(e.next(o));
    } catch (c) {
      i(c);
    }
  }, d = (o) => {
    try {
      a(e.throw(o));
    } catch (c) {
      i(c);
    }
  }, a = (o) => o.done ? s(o.value) : Promise.resolve(o.value).then(n, d);
  a((e = e.apply(t, r)).next());
});
class Je {
  constructor(r = {}) {
    if (this.inited = !1, this.timer = {}, X)
      return this.options = {}, this.deviceInfo = {}, this.transport = {}, ee();
    this.options = Object.assign(Z(), r || {}), this.transport = new Le();
    const e = new h();
    this.deviceInfo = new Fe().getFeature(), this.timer.ua_load_time = e.stop();
  }
  init() {
    return je(this, null, function* () {
      var r, e, s, i, n;
      try {
        if (this.inited) {
          S("sdk has been initialized");
          return;
        }
        const d = new h(), a = (yield Ce()).id, o = this.transport;
        this.deviceInfo.WebID = a, this.timer.webid_load_time = d.stop();
        const c = yield o.sendReportOnce(
          `${this.options.domain}/risk/report`,
          {
            WebDeviceInfo: this.deviceInfo,
            IntegrationMode: 0
          }
        );
        this.inited = !0, (e = (r = p) == null ? void 0 : r.sendEvent) == null || e.call(r, {
          name: f.REPORT_SUCCEED,
          categories: We({}, this.timer)
        }), (s = c.data) != null && s.PdID && (this.deviceInfo.PdID = c.data.PdID, yield o.sendReportLoop(
          `${this.options.domain}/risk/polling_report`,
          {
            WebDeviceInfo: this.deviceInfo,
            IntegrationMode: 0
          }
        ));
      } catch (d) {
        (n = (i = p) == null ? void 0 : i.sendEvent) == null || n.call(i, {
          name: f.API_FAIL
        });
      }
    });
  }
  getDeviceId() {
    if (!this.inited) {
      S("sdk not initialized");
      return;
    }
    return this.deviceInfo.PdID;
  }
}
export {
  Je as FingerPrint
};
